import React from "react";
import { createContext, useState, useEffect } from "react"

const SurveyFormContext = createContext({})

export const SurveyFormProvider = ({ children }) => {

    const title = {
        0: 'Parks Survey',
        1: 'Parks Survey',
    }

    const [page, setPage] = useState(0)

    const [data, setData] = useState({
        email: "",
        ageRange: "",
        recFacilities: "",
        mobility: [],
        pocketParks: [],
    })


    // useEffect(() => {
    //     if (data.sameAsBilling) {
    //         setData(prevData => ({
    //             ...prevData,
    //             shipFirstName: prevData.billFirstName,
    //             shipLastName: prevData.billLastName,
    //             shipAddress1: prevData.billAddress1,
    //             shipAddress2: prevData.billAddress2,
    //             shipCity: prevData.billCity,
    //             shipState: prevData.billState,
    //             shipZipCode: prevData.billZipCode
    //         }))
    //     } else {
    //         setData(prevData => ({
    //             ...prevData,
    //             shipFirstName: "",
    //             shipLastName: "",
    //             shipAddress1: "",
    //             shipAddress2: "",
    //             shipCity: "",
    //             shipState: "",
    //             shipZipCode: ""
    //         }))
    //     }
    // }, [data.sameAsBilling])

    function isEmail(email){
        return /^([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22))*\x40([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d))*$/.test( email );	
    }

    const handleChange = e => {
        const type = e.target.type

        const name = e.target.name

        const value = type === "checkbox"
            ? e.target.checked
            : e.target.value

        setData(prevData => ({
            ...prevData,
            [name]: value
        }))
    }

    const handleCheckboxChange = (e, setInput) => {
        const name = e.target.name

        let checkboxSet = {...data[name]}

        checkboxSet[setInput] = !checkboxSet[setInput]

        setData(prevData => ({
            ...prevData,
            [name]: checkboxSet
        }))
    }

    // pops out optional fields from list and assigns to [requiredInputs]
    const {
        billAddress2,
        sameAsBilling,
        shipAddress2,
        optInNews,
        email,
        ...requiredInputs } = data

    // const canSubmit = [...Object.values(requiredInputs)].every(Boolean) && page === Object.keys(title).length - 1
    const canSubmit = data.email && isEmail(data.email) 
    // const canSubmit = false

    // const canNextPage1 = Object.keys(data)
    //     .filter(key => key.startsWith('bill') && key !== 'billAddress2')
    //     .map(key => data[key])
    //     .every(Boolean)
    const canNextPage1 = true
  

    // const canNextPage2 = Object.keys(data)
    //     .filter(key => key.startsWith('ship') && key !== 'shipAddress2')
    //     .map(key => data[key])
    //     .every(Boolean)
    const canNextPage2 = true

    const disablePrev = page === 0

    const disableNext =
        (page === Object.keys(title).length - 1)
        || (page === 0 && !canNextPage1)
        || (page === 1 && !canNextPage2)

    const prevHide = (page === 0 || page === 1) ? "hidden" : ""

    const nextHide = (page === 0 || page === 1) ? "hidden" : ""

    const submitHide = page !== 0 && "hidden"

    return (
        <SurveyFormContext.Provider value={{ title, page, setPage, data, setData, canSubmit, handleChange, handleCheckboxChange, disablePrev, disableNext, prevHide, nextHide, submitHide }}>
            {children}
        </SurveyFormContext.Provider>
    )
}

export default SurveyFormContext 
